import { IKycData } from '../../interfaces/i-api-kyc'
import {
	FormatEnumToList,
	CountrySpecificValues,
	getMarket,
	GetAllCountriesWithTranslation,
} from '../../utils/helpers'
import {
	PurposeOfDeposit,
	MoneySource,
	OccupationType,
	TaxCountry,
	PropertyType,
} from '../../constants/kycTypes'
import { useTranslation } from 'react-i18next'
import { TranslationFile } from 'i18n'
import i18next from 'i18next'
import appConfig from 'app.config'

export const DepositInformationFormDe = (data: IKycData) => {
	const { t } = useTranslation([
		TranslationFile.Translation,
		TranslationFile.Forms,
		TranslationFile.Dropdown,
	])
	return {
		fieldSetName: t('forms:DepositInfoHeader'),
		formName: 'Third',
		show: false,
		visible: true,
		controls: [
			{
				options: FormatEnumToList(
					PurposeOfDeposit,
					PropertyType.PurposeOfDeposit,
					TranslationFile.Dropdown,
				),
				required: true,
				controlName: 'purposeOfDeposits',
				type: 'dropdown',
				label: t('forms:PurposeOfDeposits'),
				value: data.deposits[0].purposeOfDeposits,
				col: 12,
				visible: true,
			},
			{
				options: FormatEnumToList(
					MoneySource,
					PropertyType.MoneySource,
					TranslationFile.Dropdown,
				),
				required: true,
				controlName: 'moneySource',
				type: 'dropdown',
				label: t('forms:AssetsFrom'),
				value: data.deposits[0].moneySource,
				visible: true,
				col: 12,
				fullSize: true,
			},
			{
				options: CountrySpecificValues(
					TranslationFile.Dropdown,
					PropertyType.ExpectedDeposits,
				),
				required: true,
				controlName: 'expectedDeposits',
				type: 'dropdown',
				label: t('forms:ExpectedDeposits'),
				value: data.deposits[0].expectedDeposits,
				col: 12,
				visible: true,
				fullSize: false,
			},
			{
				options: CountrySpecificValues(
					TranslationFile.Dropdown,
					PropertyType.ExpectedDepositsAmount,
				),
				required: true,
				controlName: 'expectedDepositsAmount',
				type: 'dropdown',
				label: t('forms:ExpectedDepositsAmount'),
				value: data.deposits[0].expectedDepositsAmount,
				col: 12,
				visible: true,
				fullSize: false,
			},
			{
				options: CountrySpecificValues(
					TranslationFile.Dropdown,
					PropertyType.ExpectedWithdrawls,
				),
				required: true,
				controlName: 'expectedWithdrawals',
				type: 'dropdown',
				label: t('forms:ExpectedWithdrawls'),
				value: data.deposits[0].expectedWithdrawals,
				col: 12,
				visible: true,
				fullSize: false,
			},
			{
				options: CountrySpecificValues(
					TranslationFile.Dropdown,
					PropertyType.ExpectedWithdrawlsAmount,
				),
				required: true,
				controlName: 'expectedWithdrawalsAmount',
				type: 'dropdown',
				label: t('forms:ExpectedWithdrawlsAmount'),
				value: data.deposits[0].expectedWithdrawalsAmount,
				col: 12,
				visible: true,
				fullSize: false,
			},
			{
				options: FormatEnumToList(
					OccupationType,
					PropertyType.Occupation,
					TranslationFile.Dropdown,
				),
				required: true,
				controlName: 'occupationType',
				type: 'dropdown',
				label: t('forms:Occupation'),
				col: 12,
				value: data.employments[0].occupationType,
				visible: true,
			},
			{
				options: CountrySpecificValues(
					TranslationFile.Dropdown,
					PropertyType.Income,
				),
				required: true,
				controlName: 'income',
				type: 'dropdown',
				label: t('forms:AnnualIncome'),
				col: 12,
				value: data.employments[0].income,
				visible: true,
			},
			{
				options: FormatEnumToList(
					TaxCountry,
					PropertyType.TaxCountry,
					TranslationFile.Dropdown,
				),
				required: true,
				controlName: 'taxCountry',
				type: 'dropdown',
				label:
					i18next.language === 'en'
						? t('forms:ResidenceTaxPurposes', {
								country: getMarket(),
						  })
						: t('forms:ResidenceTaxPurposes'),
				col: 12,
				value: data.taxCountry,
				visible: true,
			},
			{
				options: GetAllCountriesWithTranslation(appConfig.country),
				required: true,
				controlName: 'taxCountryOther',
				type: 'dropdown',
				label: t('forms:ResidenceTaxPurposesOther'),
				col: 12,
				value: data.taxCountryOther,
				visible: false,
				condition: [
					{
						when: 'all',
						action: 'hide',
						items: [
							{
								field: 'taxCountry',
								rule: 'equal',
								value: 'Yes', //'Yes'
							},
						],
					},
				],
			},
			{
				required: true,
				controlName: 'tin',
				type: 'text',
				label: t('forms:Tin'),
				col: 12,
				value: data.tin,
				visible: false,
				condition: [
					{
						when: 'all',
						action: 'hide',
						items: [
							{
								field: 'taxCountry',
								rule: 'equal',
								value: 'Yes', //'Yes'
							},
						],
					},
				],
			},
			{
				options: [
					{
						value: 'false',
						label: t('dropdown:No'),
					},
					{
						value: 'true',
						label: t('dropdown:Yes'),
					},
				],
				required: true,
				controlName: 'fatca',
				type: 'dropdown',
				label: t('forms:Fatca'),
				col: 12,
				value: data.fatca,
				visible: true,
				tooltip: t('forms:FatcaTooltipText'),
			},
		],
	}
}
